/* SBS Tuning – sticky "Add to cart" bar on product pages (phones) */
(function () {
  function visible(el) {
    return el && el.offsetParent !== null;
  }

  function currentPrice() {
    var scope = document.querySelector('#MainContent .product__info-container .price');
    if (!scope) return '';
    var sale = scope.querySelector('.price__sale .price-item--sale');
    if (scope.classList.contains('price--on-sale') && visible(sale)) return sale.textContent.trim();
    var regular = scope.querySelector('.price__regular .price-item--regular');
    if (visible(regular)) return regular.textContent.trim();
    var any = scope.querySelectorAll('.price-item');
    for (var i = 0; i < any.length; i++) if (visible(any[i])) return any[i].textContent.trim();
    return '';
  }

  function init() {
    if (window.innerWidth >= 750) return;
    var main = document.querySelector('#MainContent .product-form__submit');
    if (!main || document.querySelector('.sbs-sticky')) return;

    var titleEl = document.querySelector('#MainContent .product__title h1, #MainContent .product__title h2');
    var bar = document.createElement('div');
    bar.className = 'sbs-sticky';
    bar.innerHTML =
      '<div class="sbs-sticky__info"><div class="sbs-sticky__title"></div><div class="sbs-sticky__price"></div></div>' +
      '<button type="button" class="sbs-sticky__btn"></button>';
    var title = bar.querySelector('.sbs-sticky__title');
    var price = bar.querySelector('.sbs-sticky__price');
    var btn = bar.querySelector('.sbs-sticky__btn');
    title.textContent = titleEl ? titleEl.textContent.trim() : '';

    var waiting = false;
    var doneTimer = null;

    function sync() {
      price.textContent = currentPrice();
      if (btn.classList.contains('is-done')) return;
      var label = main.querySelector('span');
      btn.textContent = (label ? label.textContent : main.textContent).trim();
      btn.disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
      if (waiting && !main.classList.contains('loading')) {
        waiting = false;
        btn.classList.add('is-done');
        btn.textContent = '✓ Adăugat în coș';
        clearTimeout(doneTimer);
        doneTimer = setTimeout(function () {
          btn.classList.remove('is-done');
          sync();
        }, 2200);
      }
    }

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      waiting = true;
      main.click();
    });

    document.body.appendChild(bar);
    document.body.classList.add('sbs-has-sticky');
    sync();

    new MutationObserver(sync).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
    var priceScope = document.querySelector('#MainContent .product__info-container');
    if (priceScope) new MutationObserver(function () { price.textContent = currentPrice(); }).observe(priceScope, { childList: true, subtree: true });

    /* Show the bar once the main button has scrolled above the screen */
    var ticking = false;
    function update() {
      ticking = false;
      var r = main.getBoundingClientRect();
      bar.classList.toggle('is-visible', r.bottom < 0);
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
